export class FirecatcherValueFormatter {
    public static getFormattedValue(value: number, bet: number, fractionSize: number): string {
        const currentValue = value * bet / fractionSize;
        const totalBet = bet / fractionSize;
        const totalBetFractionalValue = totalBet.toString().split('.')[1];
        let str;

        if (currentValue < 1000) {
            if (totalBet < 10) {
                str = String(currentValue.toFixed(2));
            } else {
                str = String(totalBet < 100 && totalBetFractionalValue ? currentValue.toFixed(1) : currentValue);
            }
        } else if (currentValue >= 1000 && currentValue < 1000000) {
            str = (currentValue / 1000) + 'k';
        } else {
            str = (currentValue / 1000000) + 'm';
        }

        return str;
    }
}